export const ORDER_CONFIRMATION_FIELDS = [
  "id",
  "display_id",
  "created_at",
  "currency_code",
  "status",
  "email",
  "metadata",
  "*items",
  "*shipping_address",
  "*billing_address",
  "*shipping_methods",
  "subtotal",
  "shipping_total",
  "discount_total",
  "tax_total",
  "total",
  "credit_line_total",
  "*credit_lines",
].join(",")
